
import CustomModal from "../CustomModal";
import { useLocations } from "../../../hooks/useLocations";


const EditPlanModal = ({
  isOpen,
  onClose,
  planDetails,
  onInputChange,
  onSave,
}) => {
  
  const { locations, loading: loadingLocations } = useLocations(isOpen);

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Edit modal"
      className="add-admin-modal"
    >
      <div className="add-staff-head">
        <h2>Edit Subscription Plan</h2>
      </div>

      <form onSubmit={onSave}>
        <div className="inner-form">
          <label>
            Name:
            <input
              type="text"
              name="name"
              value={planDetails.name}
              onChange={onInputChange}
              required
            />
          </label>
          <label>
            Duration (in days):
            <input
              type="number"
              name="duration_in_days"
              value={planDetails.duration_in_days}
              onChange={onInputChange}
              required
            />
          </label>
          <label>
            Amount:
            <input
              type="number"
              name="amount"
              value={planDetails.amount}
              onChange={onInputChange}
              required
            />
          </label>

          <label>
            Location:
            <select
              name="location_id"
              value={planDetails.location_id || ''}
              onChange={onInputChange}
              required
              disabled={loadingLocations}
              style={{ marginBottom: 12 }}
            >
              <option value="" disabled>
                {loadingLocations ? 'Loading locations...' : 'Select a location'}
              </option>
              {locations.map(loc => (
                <option key={loc.id} value={loc.id}>{loc.name}</option>
              ))}
            </select>
          </label>
        </div>

        <div className="modal-button">
          <button type="button" onClick={onClose}>
            Cancel
          </button>
          <input type="submit" value="Save Update" />
        </div>
      </form>
    </CustomModal>
  );
};

export default EditPlanModal;
